import { Popover } from '@mui/material';
import React from 'react'

function PopoverMui({ id, anchorEl, setAnchorEl, children }) {

    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl)

  return (
    <>
    <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {children}
      </Popover>
    </>
  )
}

export default PopoverMui